module.exports = __webpack_public_path__ + "media/landing_page/img-press-logos-da0cac16.png";